import script from "./cryptoWithdraw.vue?vue&type=script&setup=true&lang=ts"
export * from "./cryptoWithdraw.vue?vue&type=script&setup=true&lang=ts"

import "./cryptoWithdraw.vue?vue&type=style&index=0&id=1ecbe1b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ecbe1b0"]])

export default __exports__